import React, { useEffect, useState } from 'react';
import { PhoneIcon, MessageSquareIcon, MapPinIcon, AlertCircleIcon, StarIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { MapView } from '../components/MapView';
import { useApp } from '../context/AppContext';
export const RideTracking: React.FC = () => {
  const {
    currentRide,
    setCurrentRide
  } = useApp();
  const [status, setStatus] = useState<string>('searching');
  // Simulate ride progression
  useEffect(() => {
    if (status === 'searching') {
      const timer = setTimeout(() => {
        setStatus('assigned');
        setCurrentRide({
          ...currentRide,
          driverName: 'Ahmad',
          driverRating: 4.8,
          driverVehicle: 'Toyota Camry',
          driverPlate: 'JHK 1234',
          status: 'assigned'
        });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [status, currentRide, setCurrentRide]);
  const getStatusText = () => {
    switch (status) {
      case 'searching':
        return 'Finding your driver...';
      case 'assigned':
        return 'Driver is on the way';
      case 'pickup':
        return 'Driver has arrived';
      case 'checkpoint':
        return 'Clearing Immigration';
      case 'dropoff':
        return 'Arriving soon';
      default:
        return '';
    }
  };
  const getStatusChip = () => {
    switch (status) {
      case 'searching':
        return null;
      case 'assigned':
        return 'Heading to pickup';
      case 'pickup':
        return 'Heading to Checkpoint';
      case 'checkpoint':
        return 'Clearing Immigration';
      case 'dropoff':
        return 'Crossed to SG';
      default:
        return '';
    }
  };
  return <div className="min-h-screen bg-background" data-id="element-489">
      <div className="relative" data-id="element-490">
        <MapView className="h-96 w-full" showDriver={status !== 'searching'} data-id="element-491" />
        {status === 'searching' && <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-492">
            <div className="animate-pulse" data-id="element-493">
              <div className="w-16 h-16 rounded-full border-4 border-primary border-t-transparent animate-spin" data-id="element-494"></div>
            </div>
            <p className="mt-4 text-lg font-medium" data-id="element-495">{getStatusText()}</p>
          </div>}
      </div>
      <div className="p-6" data-id="element-496">
        {status !== 'searching' && <>
            {getStatusChip() && <div className="mb-4 flex justify-center" data-id="element-497">
                <div className="chip px-4 py-2" data-id="element-498">{getStatusChip()}</div>
              </div>}
            <div className="card mb-6" data-id="element-499">
              <div className="flex items-center mb-4" data-id="element-500">
                <div className="w-12 h-12 bg-primary bg-opacity-20 rounded-full flex items-center justify-center mr-3" data-id="element-501">
                  <span className="text-primary font-semibold" data-id="element-502">A</span>
                </div>
                <div data-id="element-503">
                  <h3 className="font-semibold" data-id="element-504">{currentRide.driverName}</h3>
                  <div className="flex items-center" data-id="element-505">
                    <StarIcon size={16} className="text-primary mr-1" data-id="element-506" />
                    <span className="text-sm" data-id="element-507">{currentRide.driverRating}</span>
                    <span className="mx-2" data-id="element-508">•</span>
                    <span className="text-sm" data-id="element-509">{currentRide.driverVehicle}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-510">
                <div className="flex items-center" data-id="element-511">
                  <div className="bg-card p-2 rounded-full mr-3" data-id="element-512">
                    <MapPinIcon size={20} className="text-primary" data-id="element-513" />
                  </div>
                  <div className="chip" data-id="element-514">{currentRide.driverPlate}</div>
                </div>
                <div className="flex" data-id="element-515">
                  <button className="bg-card p-3 rounded-full mr-3" data-id="element-516">
                    <MessageSquareIcon size={20} className="text-primary" data-id="element-517" />
                  </button>
                  <button className="bg-card p-3 rounded-full" data-id="element-518">
                    <PhoneIcon size={20} className="text-primary" data-id="element-519" />
                  </button>
                </div>
              </div>
              <div className="flex space-x-2" data-id="element-520">
                <Button variant="secondary" className="flex-1 py-2" data-id="element-521">
                  Change Dropoff
                </Button>
                <Button variant="secondary" className="flex-1 py-2 border-red-500 text-red-500 hover:bg-red-500 hover:bg-opacity-10" data-id="element-522">
                  Cancel Ride
                </Button>
              </div>
            </div>
            <div className="card" data-id="element-523">
              <div className="flex items-center mb-3" data-id="element-524">
                <AlertCircleIcon size={18} className="text-primary mr-2" data-id="element-525" />
                <h3 className="font-medium" data-id="element-526">Passport Reminder</h3>
              </div>
              <p className="text-sm text-white text-opacity-70" data-id="element-527">
                Please ensure you have your passport ready for immigration
                clearance at the checkpoint.
              </p>
            </div>
          </>}
      </div>
    </div>;
};